import React from 'react';
import { ExchangeRateDateEnum } from '../../../../app/shared/enums';
import { DispatchProgramInvoicingShowDataForm } from '../../../../app/models/DispatchProgramInvoicing';

interface Props {
  dispatchProgramInvoicingDataForm: DispatchProgramInvoicingShowDataForm;
  setDispatchProgramInvoicingDataForm: (dispatch: DispatchProgramInvoicingShowDataForm) => void;
  errorFields?: any;
  isShow?: boolean;
}

const DispatchProgramInvoicingShowForm: React.FC<Props> = ({
  dispatchProgramInvoicingDataForm,
  setDispatchProgramInvoicingDataForm,
  errorFields,
  isShow = false,
}) => {
  const showPrelimFixed =
    dispatchProgramInvoicingDataForm.preliminary_exchange_rate_date_reference?.id ===
    ExchangeRateDateEnum.FECHA_FIJA;

  const showFinalFixed =
    dispatchProgramInvoicingDataForm.final_exchange_rate_date_reference?.id ===
    ExchangeRateDateEnum.FECHA_FIJA;

  return (
    <div className="container-fluid">
      {/* Tipo de cambio preliminar y final */}
      <div className="row">
        {/* — Preliminar — */}
        <div className="col-lg-6 mb-3">
          <label>Tipo de Cambio Prov</label>
          <input
            type="text"
            className="form-control bg-light"
            value={dispatchProgramInvoicingDataForm.preliminary_exchange_rate_date_reference_value || ''}
            readOnly
          />

          {showPrelimFixed ? (
            <>
              <label className="form-label mt-2">Fecha Fija (Prov)</label>
              <input
                type="date"
                className="form-control bg-light"
                value={dispatchProgramInvoicingDataForm.preliminary_fixed_date || ''}
                readOnly
              />
            </>
          ) : (
            <div className="row g-2 mt-2">
              <div className="col-3">
                <label className="form-label">Días (Prov)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={dispatchProgramInvoicingDataForm.preliminary_days ?? ''}
                  readOnly
                />
              </div>
              <div className="col-3">
                <label className="form-label">Meses (Prov)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={dispatchProgramInvoicingDataForm.preliminary_months ?? ''}
                  readOnly
                />
              </div>
              <div className="col-3">
                <label className="form-label">Año (Prov)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={dispatchProgramInvoicingDataForm.preliminary_year ?? ''}
                  readOnly
                />
              </div>
            </div>
          )}

          <div className="row g-2 mt-2">
            <div className="col-6">
              <label className="form-label">
                {showPrelimFixed ? 'Fecha Fija (Prov)' : 'Fecha Ref. Tipo Cambio (Prov)'}
              </label>
              <input
                type="date"
                className="form-control bg-light"
                value={
                  showPrelimFixed
                    ? dispatchProgramInvoicingDataForm.preliminary_fixed_date || ''
                    : dispatchProgramInvoicingDataForm.preliminary_exchange_rate_date || ''
                }
                readOnly
              />
            </div>
            <div className="col-6">
              <label className="form-label">Valor Tipo Cambio (Prov)</label>
              <input
                type="text"
                className="form-control bg-light"
                value={
                  dispatchProgramInvoicingDataForm.prelim_rate !== undefined &&
                  dispatchProgramInvoicingDataForm.prelim_rate !== null
                    ? dispatchProgramInvoicingDataForm.prelim_rate
                    : ''
                }
                readOnly
              />
            </div>
          </div>
        </div>

        {/* — Final — */}
        <div className="col-lg-6 mb-3">
          <label>Tipo de Cambio Final</label>
          <input
            type="text"
            className="form-control bg-light"
            value={dispatchProgramInvoicingDataForm.final_exchange_rate_date_reference_value || ''}
            readOnly
          />

          {showFinalFixed ? (
            <>
              <label className="form-label mt-2">Fecha Fija (Final)</label>
              <input
                type="date"
                className="form-control bg-light"
                value={dispatchProgramInvoicingDataForm.final_fixed_date || ''}
                readOnly
              />
            </>
          ) : (
            <div className="row g-2 mt-2">
              <div className="col-3">
                <label className="form-label">Días (Final)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={dispatchProgramInvoicingDataForm.final_days ?? ''}
                  readOnly
                />
              </div>
              <div className="col-3">
                <label className="form-label">Meses (Final)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={dispatchProgramInvoicingDataForm.final_months ?? ''}
                  readOnly
                />
              </div>
              <div className="col-3">
                <label className="form-label">Año (Final)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={dispatchProgramInvoicingDataForm.final_year ?? ''}
                  readOnly
                />
              </div>
            </div>
          )}

          <div className="row g-2 mt-2">
            <div className="col-6">
              <label className="form-label">
                {showFinalFixed ? 'Fecha Fija (Final)' : 'Fecha Ref. Tipo Cambio (Final)'}
              </label>
              <input
                type="date"
                className="form-control bg-light"
                value={
                  showFinalFixed
                    ? dispatchProgramInvoicingDataForm.final_fixed_date || ''
                    : dispatchProgramInvoicingDataForm.final_exchange_rate_date || ''
                }
                readOnly
              />
            </div>
            <div className="col-6">
              <label className="form-label">Valor Tipo Cambio (Final)</label>
              <input
                type="text"
                className="form-control bg-light"
                value={
                  dispatchProgramInvoicingDataForm.final_rate !== undefined &&
                  dispatchProgramInvoicingDataForm.final_rate !== null
                    ? dispatchProgramInvoicingDataForm.final_rate
                    : ''
                }
                readOnly
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DispatchProgramInvoicingShowForm;
